import { TOGGLE_FORCE_TRIGGER } from "../actions";

export default function forceTrigger(state = false, action) {
  switch (action.type) {
    case TOGGLE_FORCE_TRIGGER:
      return !state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/forceTrigger.js